import React, { Component } from 'react';
import { connect } from 'react-redux'
import {withRouter} from 'react-router';
import { addFrontEndUser, userEdited } from '../../actions/frontEndUser';
import { Button, Form, FormGroup, Label, Input, FormText, Card, CardBody, CardTitle } from 'reactstrap';
import FrontEndUserAddresses from './Addresses'

class FrontEndUserForm extends Component {  

    constructor(props,context) {
        super(props,context);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setCheckedAddresses = this.setCheckedAddresses.bind(this);
        this.state = {postData: false, edit: false, 'frontEndUserData': false, 'attached_addresses': false}
    }

    componentWillMount()
    {

        if(this.props.match.params.userId)
        {

            const userId = this.props.match.params.userId;
            const frontEndUser = this.props.frontEndUserData.data.find(e => e.id === userId);
            this.setState({'edit': true, 'postData': frontEndUser, 'frontEndUserData': frontEndUser, 'attached_addresses': frontEndUser.addresses})
            
        }

       
    }

    handleSubmit(e) {
        e.preventDefault();       
      
        this.props.addFrontEndUser(
            this.props.clientPath.clientPath, 
            this.state.postData,
            this.state.attached_addresses
        );
    }

    setInputState(e) {              
      this.setState({
          postData: {...this.state.postData, [e.target.name]: e.target.value }

      });   
    }

    setCheckedValue(e) {
        this.setState({
            postData: {...this.state.postData, [e.target.name]: e.target.checked ? 1 : 0 }
        })
    }

    setCheckedAddresses(e) {

        if((this.state.attached_addresses) && e.target.value in this.state.attached_addresses) {            
            delete this.state.attached_addresses[e.target.value];
        }else {
            this.setState({
                attached_addresses: {...this.state.attached_addresses, [e.target.value]: e.target.value}
            })    
        }
    }

    componentDidUpdate(prevprops, prevstate) {      

        if(this.props.frontEndUserData.hasBeenEdited) {
            this.props.userEdited(false);
            this.props.history.push('/user/view/')
        }
    }

    render() {  
            
        return (
            <div className="animated fadeIn">  
             <Card>
                <CardBody>
                    <CardTitle><i className="fa fa-user"></i> Gebruiker {this.state.edit ? 'bewerken' : 'toevoegen'}</CardTitle>   
                    <Form onSubmit={(e) => this.handleSubmit(e)}>         
                     {/*<FormGroup>
                            <Label for="parent_id">Hoofdgebruiker</Label>
                            <Input type="select" name="parent_id" defaultValue={this.state.postData ? this.state.postData.parent_id : ""} onChange={(e) => this.setInputState(e)} id="parent_id">
                            <option value="">Kies een hoofdgebruiker</option>
                                {this.props.frontEndUserData.data.map(val => {  
                                    if(this.state.frontEndUserData) {
                                         if(val.is_main_account === '1' && val.id != this.state.frontEndUserData.id){                                      
                                            return (<option  key={val.id} value={val.id}>{val.name}</option>)
                                         }
                                    } else {
                                        if(val.is_main_account === '1'){                                      
                                            return (<option  key={val.id} value={val.id}>{val.name}</option>)
                                        } 
                                    }                               
                              })}
                            </Input>                                   
                        </FormGroup>  */} 
                    <FormGroup>
                        <Label for="name">Naam</Label>
                        <Input type="text" defaultValue={this.state.frontEndUserData ? this.state.frontEndUserData.name : ''} onChange={(e) => this.setInputState(e)} name="name" id="name" placeholder="Naam" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="email">Email</Label>
                        <Input type="email" defaultValue={this.state.frontEndUserData ? this.state.frontEndUserData.email : ''} onChange={(e) => this.setInputState(e)} name="email" id="email" placeholder="E-mail" />
                    </FormGroup>
                    {/*<FormGroup>
                        <Label for="password">Wachtwoord</Label>
                        <Input type="password" onChange={(e) => this.setInputState(e)} name="password" id="password" placeholder="Wachtwoord" />
                    </FormGroup>*/}
                    <FormGroup>
                        <Label for="telephone">Telefoonnummer</Label>
                        <Input type="text"  defaultValue={this.state.frontEndUserData ? this.state.frontEndUserData.telephone : ''} onChange={(e) => this.setInputState(e)} name="telephone" id="telephone" placeholder="Telefoonnummer" />
                    </FormGroup>
                    <FormGroup check>
                        <Label check for="is_active">
                            <Input type="checkbox" defaultChecked={this.state.frontEndUserData && this.state.frontEndUserData.is_active === '1' ? true : false} onChange={(e) => this.setCheckedValue(e)} name="is_active" id="is_active" />
                            Is actief?
                        </Label>
                    </FormGroup>                    
                    <FormGroup check>
                        <Label check for="is_representative">
                            <Input type="checkbox" defaultChecked={this.state.frontEndUserData && this.state.frontEndUserData.is_representative == '1' ? true : false} onChange={(e) => this.setCheckedValue(e)} name="is_representative" id="is_representative" />
                            Is vertegenwoordiger?
                        </Label>
                    </FormGroup>
                    <FormGroup check>
                        <Label check for="mobile_verification">
                            <Input type="checkbox" defaultChecked={this.state.frontEndUserData && this.state.frontEndUserData.mobile_verification == '1' ? true : false} onChange={(e) => this.setCheckedValue(e)} name="mobile_verification" id="mobile_verification" />
                            Mobiele verificatie?
                        </Label>
                    </FormGroup>
                    <FormGroup check>
                        <Label check for="is_dps_user">
                            <Input type="checkbox" defaultChecked={this.state.frontEndUserData && this.state.frontEndUserData.is_dps_user == '1' ? true : false} onChange={(e) => this.setCheckedValue(e)} name="is_dps_user" id="is_dps_user" />
                            Is ook een DPS gebruiker?
                        </Label>
                    </FormGroup>
                    {/*<FrontEndUserAddresses attachedAddresses={this.state.attached_addresses} setCheckedAddresses={this.setCheckedAddresses} />*/}

                    <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-dot-circle-o"></i> {this.state.edit ? 'Bijwerken' : 'Toevoegen'}</button>
                    </Form>
                </CardBody>

            </Card>
            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        frontEndUserData: state.FrontEndUserReducer,
        clientPath: state.clientPathReducer         
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addFrontEndUser: (url, postData, attached_addresses) => dispatch(addFrontEndUser(url, postData, attached_addresses)),
        userEdited : (status) => dispatch(userEdited(status))

    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FrontEndUserForm))



// WEBPACK FOOTER //
// ./src/views/User/form.js